import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
import { getAllPayrolls } from "../../services/payroll.service";
import PayrollDialog from "../../components/PayrollDialog";
import CreatePayrollDialog from "components/CreatePayrollDialog";
import { getMentorsList } from "services/mentor.service";

function Payroll(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const mentor = searchParams.get("mentor");
  const [data, setData] = useState(false);
  const [updateView, forceUpdateView] = useState(false);
  const [selectedPayroll, setSelectedPayroll] = useState();
  const [createPayrollDialog, setCreatePayrollDialog] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();
  const [mentors, setMentors] = useState([]);

  useEffect(() => {
    async function mentorApi() {
      try {
        setProgress(true);
        const res = await getMentorsList();
        if (res) {
          setMentors(res);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }

        setProgress(false);
      } catch (error) {
        // error

        console.log(error);
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }

    async function api() {
      try {
        setProgress(true);
        const filters = {};
        if (mentor) {
          filters.mentor = mentor;
        }
        const data = await getAllPayrolls(filters);
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    mentorApi();
    api();
  }, [updateView, isRefreshed]);

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>
            <Link
              to={"/dashboard/courses/edit/" + row.course?._id}
              className="hover:underline"
            >
              {row.course ? row.course?.name : "-"}
            </Link>
          </TableCell>
          <TableCell>
            {row.course
              ? Constants.CURRENCY_SYMBOL + row.course?.salePrice
              : "-"}
          </TableCell>
          <TableCell>
            <Link
              to={"/dashboard/mentors/" + row.mentor?._id}
              className="hover:underline"
            >
              {row.mentor
                ? row.mentor.firstname + " " + row.mentor.lastname
                : "-"}
            </Link>
          </TableCell>
          <TableCell>
            {row.amount ? Constants.CURRENCY_SYMBOL + row.amount : "Not Set"}
          </TableCell>
          <TableCell>{row.topicName ?? "-"}</TableCell>
          <TableCell>{row.batchNumber ?? "-"}</TableCell>
          <TableCell>{row.sessionNumber ?? "-"}</TableCell>
          <TableCell>
            {moment(row.sessionStartTime).format("h:mm a") +
              "-" +
              moment(row.sessionEndTime).format("h:mm a") +
              " " +
              moment(row.sessionStartTime).format("DD/MM/YYYY")}
          </TableCell>
          <TableCell>{row.status}</TableCell>
          <TableCell>{row.statusMessage ?? "Not Set"}</TableCell>
          <TableCell>
            {row.completedAt
              ? moment(row.completedAt).format("dddd, MMMM Do YYYY, h:mm a")
              : "Not Yet"}
          </TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
          <TableCell>
            {row.status === "PENDING" ? (
              <div className="flex gap-5">
                <Button
                  size="small"
                  color="success"
                  variant="contained"
                  onClick={(e) =>
                    setSelectedPayroll({
                      status: "PROCESSING",
                      id: row._id,
                    })
                  }
                >
                  Payout
                </Button>

                <Button
                  size="small"
                  color="error"
                  variant="contained"
                  onClick={(e) =>
                    setSelectedPayroll({
                      status: "CANCELLED",
                      id: row._id,
                    })
                  }
                >
                  Cancel
                </Button>
              </div>
            ) : null}

            {/* <Button
              size="small"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit/" + row._id, {
                  state: { mentor: row },
                });
              }}
            >
              Change
            </Button> */}
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        {mentor && data && (
          <h1 className="text-sm">
            Showing Results for :{" "}
            <b>
              {data[0] && data[0].mentor.firstname
                ? data[0].mentor.firstname + " " + data[0].mentor.lastname
                : mentor}
            </b>
          </h1>
        )}
        <div className="md:ml-auto flex items-end gap-2 justify-end">
          <Button
            variant="outlined"
            onClick={() => {
              setCreatePayrollDialog(true);
            }}
          >
            Create Payout +
          </Button>
        </div>
        <TableContainer>
          <div className="flex justify-end gap-5">
            {/* <Button
              variant="outlined"
              className="my-8"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit");
              }}
            >
              Create Payroll
            </Button> */}
          </div>
          <Table size="small">
            <TableHead className="">
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Course</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Course Price
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Mentor</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Amount</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Topic Name</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Class Number
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Session Number
                </TableCell>

                <TableCell style={{ fontWeight: "bold" }}>
                  Session Time
                </TableCell>

                <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Status Message
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Completed At
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>
      </Box>

      <PayrollDialog
        hooks={[selectedPayroll, setSelectedPayroll]}
        setToast={setToast}
        forceUpdateView={forceUpdateView}
      />

      <CreatePayrollDialog
        open={createPayrollDialog}
        onClose={() => {
          setCreatePayrollDialog(false);
        }}
        onCreate={() => {}}
        mentors={mentors}
      />

      {/* <MentorVerificationStatusDialog
          setMentorVerificationStatus={setMentorVerificationStatus}
          mentorVerificationStatus={mentorVerificationStatus}
          setToast={setToast}
          onUpdate={() => {
            setUpdate(update + 1);
          }} */}
    </div>
  );
}

export default Payroll;
